import { __decorate, __metadata } from "tslib";
import { Fingerprintable, IsNotEmptyObjectWithLVS, IsUndefinable, SupportedCurrencyEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Min, ValidateIf, ValidateNested } from 'class-validator';
import { PromotionSubTypeEnum, PromotionTypeEnum } from '../../common';
import { PromotionExposeGroup } from '../interface';
import { PutPromocodeTemplateUsageRulesDto } from './PutPromocodeTemplateUsageRulesDto';
import { PutPromotionConditionsDto } from './PutPromotionConditionsDto';
import { PutPromotionDiscountDto } from './PutPromotionDiscountDto';
import { PutPromotionImagesDto } from './PutPromotionImagesDto';
import { PutPromotionMerchantGroupDto } from './PutPromotionMerchantGroupDto';
import { PutPromotionProviderDto } from './PutPromotionProviderDto';
let PutPromotionDto = class PutPromotionDto {
    constructor() {
        this.isTemplate = false;
        this.type = PromotionTypeEnum.PROMOTION;
        this.priority = 1;
        this.isCumulative = false;
        this.compatible = [];
        this.tags = [];
    }
};
__decorate([
    ApiProperty({ type: () => String, description: 'PromoCode, as in 10LUCKY ', example: 'MISSU10' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PUT] }),
    IsString({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PUT] }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "promotionId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'promotion uniqueName, (is in use somewhere) or can be uuid/guid', example: 'MISSU10_CHELSEA' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [PromotionExposeGroup.CREATE] }),
    IsNotEmpty({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PUT] }),
    IsString({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PUT] }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "uniqueName", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, description: 'is this promotion used as promo-code' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PutPromotionDto.prototype, "isPromoCode", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'promoCode text', example: 'TEST10VIP' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    ValidateIf((o) => !!(o === null || o === void 0 ? void 0 : o.isPromoCode), { always: true }),
    IsNotEmpty({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.PUT] }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "promoCode", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, description: 'is promotion active' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PutPromotionDto.prototype, "isActive", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsBoolean({ always: true }),
    IsUndefinable({ always: true }),
    __metadata("design:type", Boolean)
], PutPromotionDto.prototype, "isTemplate", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => PutPromocodeTemplateUsageRulesDto),
    IsOptional({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    __metadata("design:type", PutPromocodeTemplateUsageRulesDto)
], PutPromotionDto.prototype, "templateUsageRules", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Promotion type', default: PromotionTypeEnum.PROMOTION, example: PromotionTypeEnum.PROMOTION }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "type", void 0);
__decorate([
    ApiProperty({
        enum: PromotionSubTypeEnum,
        description: `subtype of promotion -  ${Object.values(PromotionSubTypeEnum).join(' | ')}`,
        example: PromotionSubTypeEnum.LOYALTY,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsEnum(PromotionSubTypeEnum, { always: true }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "subtype", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'arbitrary text, short title', example: '10% Off' }),
    Expose({
        groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE, PromotionExposeGroup.PROFILER],
    }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'arbitrary text, subtitle', example: 'Get 10% Off Your Online Order!' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "subtitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'arbitrary text', example: '15% discount on your first order.' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "message", void 0);
__decorate([
    ApiProperty({ type: () => PutPromotionImagesDto }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => PutPromotionImagesDto),
    ValidateNested({ always: true }),
    __metadata("design:type", PutPromotionImagesDto)
], PutPromotionDto.prototype, "images", void 0);
__decorate([
    ApiProperty({ type: () => PutPromotionConditionsDto }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => PutPromotionConditionsDto),
    ValidateNested({ always: true }),
    __metadata("design:type", PutPromotionConditionsDto)
], PutPromotionDto.prototype, "conditions", void 0);
__decorate([
    ApiProperty({ enum: SupportedCurrencyEnum, description: 'currency of the cart/cart-item, constant, always "USD" ', example: SupportedCurrencyEnum.USD }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsEnum(SupportedCurrencyEnum, { always: true }),
    __metadata("design:type", String)
], PutPromotionDto.prototype, "currency", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'price of the cart-item, constant, always "0.0" ', example: 0.0 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], PutPromotionDto.prototype, "price", void 0);
__decorate([
    ApiProperty({ type: () => PutPromotionDiscountDto }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => PutPromotionDiscountDto),
    ValidateNested({ always: true }),
    __metadata("design:type", PutPromotionDiscountDto)
], PutPromotionDto.prototype, "discount", void 0);
__decorate([
    ApiProperty({ type: () => PutPromotionProviderDto }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => PutPromotionProviderDto),
    ValidateNested({ always: true }),
    __metadata("design:type", PutPromotionProviderDto)
], PutPromotionDto.prototype, "provider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    IsInt({ groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    Min(1, { groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    __metadata("design:type", Number)
], PutPromotionDto.prototype, "priority", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    IsBoolean({ groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    __metadata("design:type", Boolean)
], PutPromotionDto.prototype, "isCumulative", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    IsString({ each: true, groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    IsNotEmpty({ each: true, groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    __metadata("design:type", Array)
], PutPromotionDto.prototype, "compatible", void 0);
__decorate([
    ApiProperty({ type: () => PutPromotionMerchantGroupDto }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => PutPromotionMerchantGroupDto),
    ValidateNested({ always: true }),
    __metadata("design:type", PutPromotionMerchantGroupDto)
], PutPromotionDto.prototype, "group", void 0);
__decorate([
    ApiProperty({ type: () => String, isArray: true }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    __metadata("design:type", Array)
], PutPromotionDto.prototype, "tags", void 0);
PutPromotionDto = __decorate([
    Fingerprintable()
], PutPromotionDto);
export { PutPromotionDto };
//# sourceMappingURL=PutPromotionDto.js.map